module.exports = __webpack_public_path__ + "static/media/alfred_portrait_2.58065201.jpeg";